import { InjectedFormProps } from 'redux-form';

export type PeriodsFormProps = InjectedFormProps;

export interface PeriodsForm {
  entity: Period;
}

export interface Period {
  id?: string;
  updated?: Date;
  created?: Date;
  deleted?: Date;
  from?: any;
  to?: any;
  type?: PeriodType;
}

export interface PeriodEnhancerProps<Entity> {
  getEntity: (actions: object) => (item: string) => Promise<Entity>;
  defaultEntity: {};
}

export enum PeriodType {
  VACATION = 'VACATION',
  MAGIVOZ = 'MAGIVOZ',
  COMP_TIME_OFF = 'COMP_TIME_OFF',
  BLOOD_DONATION = 'BLOOD_DONATION',
  OTHER_VACATION_WEDDING = 'OTHER_VACATION_WEDDING',
  OTHER_VACATION_FUNERAL = 'OTHER_VACATION_FUNERAL',
  OTHER_VACATION_DOCTOR = 'OTHER_VACATION_DOCTOR',
  OTHER_VACATION_UNPAID = 'OTHER_VACATION_UNPAID',
  OVERTIME_25 = 'OVERTIME_25',
  OVERTIME_50 = 'OVERTIME_50',
  CONT_TIME_OFF = 'CONT_TIME_OFF',
  WORKING_HOURS = 'WORKING_HOURS',
  SAFETY_SWITCH = 'SAFETY_SWITCH',
  BREAK = 'BREAK',
  UNEXCUSED_ASBENCE = 'UNEXCUSED_ASBENCE',
  ILLNESS = 'ILLNESS',
  INDISPOSED_VACATION = 'INDISPOSED_VACATION',
  OVERTIME = 'OVERTIME',
  OVERTIME_SUBSTITUTE_VACATION = 'OVERTIME_SUBSTITUTE_VACATION',
  OVERTIME_UNPAID = 'OVERTIME_UNPAID'
}



// WEBPACK FOOTER //
// ./src/modules/hr-templates/periods/_periodsTypes.ts